import React, { Component } from "react"
import './userRecord.less'






export default class PowerStation extends Component {
	constructor(props) {
		super(props);
		this.state={}
	}
	render() {
		return (
			<div>
			   <p>使用记录</p>
			</div>
		)
	}
}